exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.footer-warning[data-v-28754768]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/invoice-audit/PageInvoiceAudit.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,YAAY;CACb","file":"PageInvoiceAudit.vue","sourcesContent":["\n.footer-warning[data-v-28754768]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28754768","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/PageInvoiceAudit.vue
// module id = d05t
// module chunks = 72